import React from 'react';
import './index.css';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<App data-id="element-2281" data-mp="219oagcpss419" />);